import { I18N } from 'aurelia-i18n';
import { AccountPaymentItem } from '../../../../models/account-payment-item';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class MeetsAccountMinAmountRule implements IValidationRule {
	constructor(private i18n: I18N, private items: AccountPaymentItem[]) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();

		// enforce customer account minimum payment due if necessary
		let isValid: boolean = true;

		this.items.forEach((i: AccountPaymentItem) => {
			if (i.isSelected) {
				if (isValid && i.paymentLimitSettings.enableMinimumPaymentDueOnAccount) {
					let parsedAmount: number = parseFloat(i.enteredAmount);
					if (isNaN(parsedAmount) || parsedAmount < i.minPaymentDue) {
						isValid = false;
					}
				}
			}
		});

		result.isValid = isValid;

		if (!result.isValid) {
			result.errorMessage = this.i18n.i18next.t('accountPaymentAmountMeetMinimumDue',
				'Payment Amount for account must be greater than or equal to minimum payment due.');
		}

		return result;
	}
}
